import * as Yup from "yup";

export const newUserFormValidationSchema = (isAddMode) =>
  Yup.object({
    name: Yup.string().required("Name is Required"),
    login: Yup.string().required("Email is required."),
    password: isAddMode
      ? Yup.string()
          .required("Password is Required")
          .min(8, "Password must be at least 8 characters long")
          .matches(
            /[a-z]/,
            "Password must contain at least one lowercase letter"
          )
          .matches(
            /[A-Z]/,
            "Password must contain at least one uppercase letter"
          )
          .matches(/[0-9]/, "Password must contain at least one number")
          .matches(
            /[@$!%*?&#]/,
            "Password must contain at least one special character"
          )
      : Yup.string().notRequired(),
  });
